<template>
<v-container fluid>
  <toast v-model="toastText"></toast>
  <v-layout wrap color="transparent" v-if="!loading">
    <v-flex xs12 sm6 md3>
      <v-select :disabled="isNotFilterable" v-model="searchGateway" :items="macList" prepend-icon="wifi_tethering" :placeholder="$t('device.filter_by_gateway')" class="px-3 mt-0" clearable hide-details>
        <template slot="item" slot-scope="data">
          <v-list-tile-content>
            <v-list-tile-title v-text="data.item.text"></v-list-tile-title>
            <v-list-tile-sub-title class="caption" v-text="data.item.value"></v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md3>
      <v-text-field :disabled="isNotFilterable" v-model="searchWord" prepend-icon="search" :placeholder="$t('device.search')" class="px-3 mt-0 mb-4" hide-details single-line clearable></v-text-field>
    </v-flex>
  </v-layout>
  <v-layout row justify-center v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row justify-center v-else-if="allDevices.length===0">
    <span class="title grey--text mt-5">{{ $t('device.no_device_available') }}</span>
  </v-layout>
  <v-layout row justify-center v-else-if="filteredDevices.length===0">
    <span class="title grey--text mt-5 text-xs-center">{{ $t('device.no_device_matched') }}</span>
  </v-layout>
  <v-layout row wrap v-else>
    <v-flex xl2 lg3 md4 sm6 xs12 v-for="d in limitFilteredDevices" :key="d.key" class="px-1 py-1">
      <device-item :item="d"></device-item>
    </v-flex>
  </v-layout>
  <v-layout justify-center v-if="limit<filteredDevices.length" class="py-4">
    <v-tooltip bottom>
      <v-btn fab color="light-grey" slot="activator" @click="moreItem">
        <v-icon>expand_more</v-icon>
      </v-btn>
      <span>{{ $t('device.show_more') }}</span>
    </v-tooltip>
  </v-layout>
</v-container>
</template>

<script>
import deviceItem from './deviceItem'
import {
  UserAuth,
  DeviceAction
} from 'luffanet-web-components'

const INIT_LIMIT = 50;

export default {
  name: 'Device',
  mixins: [UserAuth],
  components: {
    'device-item': deviceItem,
    'device-action': DeviceAction
  },
  data() {
    return {
      toastText: null,
      loading: true,
      device: [],
      userMac: [],
      searchWord: null,
      searchGateway: null,
      limit: INIT_LIMIT
    }
  },
  watch: {
    searchWord(val) {
      this.limit = INIT_LIMIT;
    },
    searchGateway(val) {
      this.limit = INIT_LIMIT;
    }
  },
  computed: {
    allDevices() {
      let list = [];
      this.device.forEach(gateway => {
        let mac = gateway['.key'];
        Object.keys(gateway).filter(mac => mac !== '.key').forEach(id => {
          let device = gateway[id];
          if(device.functype < 99) list.push(Object.assign({
            key: mac + '-' + id
          }, device));
        });
      });
      return list;
    },
    filteredDevices() {
      let data = this.allDevices;

      if(data && this.searchGateway && this.searchGateway.length > 0)
        data = data.filter(item => item.key.startsWith(this.searchGateway));

      if(data && this.searchWord && this.searchWord.length > 0)
        data = data.filter(item => [
            item.key,
            item.name,
            item.room,
            item.targetName
          ]
          .join(' ')
          .toLowerCase()
          .indexOf(this.searchWord.toLowerCase()) != -1);

      return data;
    },
    limitFilteredDevices() {
      return this.filteredDevices.slice(0, this.limit);
    },
    isNotFilterable() {
      return !this.userId || this.allDevices.length == 0;
    },
    macList() {
      return this.userMac.map(m => ({
        text: m.hostname,
        value: m['.key']
      }))
    }
  },
  methods: {
    load() {
      this.$bindAsArray('userMac', this.$db.ref('macInfo').child(this.userId), null, function() {
        //this.loading = false;
      });
      this.$bindAsArray('device', this.$db.ref('device').child(this.userId), null, function() {
        this.loading = false;
      });
    },
    moreItem() {
      this.limit += INIT_LIMIT;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device.vue